var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_pg-app"}},[(_vm.License.isVisitarBodegas())?_c('VisitarBodegas'):(_vm.License.isSafareigTermal())?_c('SafareigTermal'):(_vm.License.isCastellDelRemei())?_c('CastellDelRemei'):_c('MainLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }